const videoConfig = {
  brightcove: {
    liveStream: {
      accountId: '710857117001',
      testVideoId: '6298856962001',
    },
    master: {
      accountId: '1241706627001',
      testVideoId: '6298850459001',
    },
  },
  translate: {
    youtube: { providerType: 'youtube', videoId: 'CadZpJ7AlvQ' },
    brightcove: { providerType: 'youtube', videoId: 'PexANw32ywM' },
  },
  suppressedPlayerErrors: [
    'The node before which the new node is to be inserted is not a child of this node',
  ],
}

export default videoConfig
